export default __webpack_public_path__ + "static/media/memory-game.b6e5d364.png";